var $$ = $$ || {};

$$.CollapseBlocks = class CollapseBlocks {
	constructor (root) {
		this.root = root;

		this._cacheNodes();
		this._bindEvents();
	}

	_cacheNodes () {
		this.nodes = {
			block: this.root.find('.js-collapse-block')
		};
	}

	_bindEvents () {
		this.nodes.block.on('click', (event) => {
			$(event.currentTarget).toggleClass('opened');
		});
	}
};
